export const getDepartmentName = (address: string) => {
  return address?.replace(/^.*?(?=Відділення|Отделение)/i, '').trim();
};
